var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 23.3335H116.667C123.083 23.3335 128.333 28.5835 128.333 35.0002V105C128.333 111.417 123.083 116.667 116.667 116.667H23.3333C16.9166 116.667 11.6666 111.417 11.6666 105V35.0002C11.6666 28.5835 16.9166 23.3335 23.3333 23.3335Z",
    stroke: "#FF5880",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.333 35L70 75.8333L11.6666 35",
    stroke: "#FF5880",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.3a67c0a65ca305c865f321c48a31da4a.svg";
export { ForwardRef as ReactComponent };